export default __webpack_public_path__ + "static/media/mainart.8e4b0107.jpg";